import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IntennseOfficialViewComponent } from './intennse-official-view.component';

const routes: Routes = [
  {
    path: ':id',
    component: IntennseOfficialViewComponent,
    title: 'iOnCourt | Intennse Official View',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TempIntennseViewRoutingModule {}
